module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-10_e23e2f3d02b9c0a6594b9faf54f4e8df.png";